import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-item-overtimes',
    name: 'pay-item-overtime',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-item-overtime')
  }
]
